export default __webpack_public_path__ + "static/media/google-plus-circle.91438ab8.svg";